import React from 'react';

/* The external-link arrow is the font’s own “→” glyph rotated 45°, not an SVG.
   A drawn icon carries a fixed stroke weight (and rounded caps), which looks
   thick next to the thin text arrows used elsewhere on the page. This version
   inherits the font, the weight and the size of whatever it sits inside. */
export default function ArrowUpRight() {
    return (
        <span className="arrow-up-right" aria-hidden="true">
            →
        </span>
    );
}
